<template>
    <li class="limit-goods-item">
        <div class="goods-main">
            <img :src="cover" alt="商品" class="goods-img">
            <div class="goods-info">
                <img src="../images/coin.png" alt="金币" class="goods-coin">
                <div class="goods-value">
                    <span class="goods-price-primary">{{ discountPrice }}</span>
                    <span class="goods-price">{{ price }}</span>
                </div>
            </div>
        </div>
        <div class="goods-footer">
            <img src="../images/icon-timer.png" alt="" class="goods-timer-icon">
            <CountDown :endTime="endTime" />
        </div>
    </li>
</template>

<script>
import CountDown from '@/components/CountDown.vue';

export default {
    name: 'GoodsItem',
    components: {
        CountDown,
    },
    props: {
        cover: {
            type: String,
            default: '',
        },
        discountPrice: {
            type: Number,
            default: 0,
        },
        price: {
            type: Number,
            default: 0,
        },
        endTime: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style scoped>
.limit-goods-item {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.goods-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 12px 0 12px;
    border-bottom: 1px solid rgba(153,37,6,0.41);
    width: 182px;
    background: url(../images/bg-paw.png) bottom left/82px no-repeat #fff3d3;
    border-radius: 24px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
}
.goods-img {
    width: 158px;
    height: 170px;
    object-fit: cover;
    border-radius: 30px;
}
.goods-info {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    font-size: 28px;
    font-weight: bold;
    color: #EA921D;
}
.goods-coin {
    width: 42px;
    height: 42px;
    margin-right: 20px;
}
.goods-value {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.goods-price-primary {
    line-height: 1;
    font-size: 36px;
    font-weight: bold;
    color: #EA921D;
}
.goods-price {
    line-height: 1;
    text-decoration: line-through;
    font-size: 24px;
    color: #868686;
}

.goods-footer {
    display: flex;
    align-items: center;
    padding: 6px 0;
    font-size: 24px;
    font-weight: bold;
    color: #fff;
}
.goods-timer-icon {
    width: 34px;
    height: 34px;
    margin-right: 10px;
    margin-top: 2px;
}
</style>